export class Subscribable {
    constructor() {
        this.listeners = new Set();
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return {
            unsubscribe: () => this.listeners.delete(listener),
        };
    }
    updateInternal(payload) {
        for (const listener of this.listeners) {
            listener(payload);
        }
    }
}
export class Observable extends Subscribable {
    constructor(value) {
        super();
        this.value = value;
    }
    update(newValue) {
        this.value = newValue;
        this.updateInternal();
    }
}
//# sourceMappingURL=observable.js.map